document.addEventListener('DOMContentLoaded', function() {
    initializeCartDiscountHandling();
    displayAppliedDiscount(); // Show any already applied discount on page load
});

function initializeCartDiscountHandling() {
    const updateCartButton = document.querySelector('.update-cart');
    const discountInput = document.getElementById('customPgAppDiscountCode');
    const discountField = document.querySelector('.cart__discount-code');
    
    // Always show the discount field to ensure it's accessible
    if (discountField) {
        discountField.style.display = 'block';
    }
    
    // Check if there's an applied discount in localStorage and pre-fill the input
    const appliedDiscount = localStorage.getItem('appliedDiscountCode');
    if (appliedDiscount && discountInput) {
        discountInput.value = appliedDiscount;
    }
    
    if (updateCartButton) {
        updateCartButton.addEventListener('click', function(e) {
            e.preventDefault();
            
            const discountCode = discountInput ? discountInput.value.trim() : '';
            
            if (discountCode) {
                updateCartWithDiscount(discountCode);
            } else {
                // No discount code, submit form normally
                const cartForm = document.querySelector('form[action="/cart"]');
                if (cartForm) {
                    cartForm.submit();
                }
            }
        });
    }
}

function updateCartWithDiscount(code) {
    // Show loading state
    const updateButton = document.querySelector('.update-cart');
    const originalText = updateButton.textContent;
    updateButton.textContent = 'Applying Discount...';
    updateButton.disabled = true;
    
    // Store the discount code in localStorage before applying
    localStorage.setItem('appliedDiscountCode', code);
    
    fetch('/cart/update.js', {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
        },
        body: JSON.stringify({
            discount: code
        })
    })
    .then(response => {
        if (!response.ok) {
            throw new Error('Network response was not ok');
        }
        return response.json();
    })
    .then(data => {
        // Restore button state
        updateButton.textContent = originalText;
        updateButton.disabled = false;
        
        if (data.errors) {
            alert('Discount error: ' + data.errors);
            localStorage.removeItem('appliedDiscountCode'); // Remove invalid code
        } else {
            // Success - reload to see updated prices
            window.location.href = '/cart';
        }
    })
    .catch(error => {
        console.error('Error:', error);
        // Restore button state
        updateButton.textContent = originalText;
        updateButton.disabled = false;
        alert('Error applying discount code: ' + error.message);
        localStorage.removeItem('appliedDiscountCode');
    });
}

function displayAppliedDiscount() {
    const appliedDiscount = localStorage.getItem('appliedDiscountCode');
    const discountInput = document.getElementById('customPgAppDiscountCode');
    const discountField = document.querySelector('.cart__discount-code');
    
    if (!appliedDiscount || !discountField) return;
    
    // Create or update the display for applied discount
    let discountDisplay = document.getElementById('appliedDiscountDisplay');
    
    if (!discountDisplay) {
        discountDisplay = document.createElement('div');
        discountDisplay.id = 'appliedDiscountDisplay';
        discountDisplay.className = 'applied-discount-message';
        
        // Insert after the discount input wrapper
        const discountWrapper = discountField.querySelector('.discount-code-wrapper');
        if (discountWrapper) {
            discountWrapper.parentNode.insertBefore(discountDisplay, discountWrapper.nextSibling);
        }
    }
    
    discountDisplay.innerHTML = `
        <div style="margin-top: 10px; padding: 10px; background: #f8f8f8; border-radius: 4px; border-left: 4px solid #4CAF50;">
            <strong>Applied Discount:</strong> ${appliedDiscount}
            <button type="button" id="removeDiscount" style="margin-left: 10px; background: #ff4444; color: white; border: none; padding: 2px 8px; border-radius: 3px; cursor: pointer; font-size: 12px;">
                Remove
            </button>
        </div>
    `;
    
    // Add event listener for remove button
    document.getElementById('removeDiscount').addEventListener('click', function() {
        removeDiscountCode();
    });
    
    // Pre-fill the input with the applied code
    if (discountInput) {
        discountInput.value = appliedDiscount;
        discountInput.disabled = true; // Optional: disable input when code is applied
    }
}

function removeDiscountCode() {
    // Show loading state
    const updateButton = document.querySelector('.update-cart');
    const originalText = updateButton.textContent;
    updateButton.textContent = 'Removing Discount...';
    updateButton.disabled = true;
    
    fetch('/cart/update.js', {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
        },
        body: JSON.stringify({
            discount: ''
        })
    })
    .then(response => {
        if (!response.ok) {
            throw new Error('Network response was not ok');
        }
        return response.json();
    })
    .then(data => {
        // Remove from localStorage
        localStorage.removeItem('appliedDiscountCode');
        
        // Restore button state
        updateButton.textContent = originalText;
        updateButton.disabled = false;
        
        // Reload to see updated prices
        window.location.href = '/cart';
    })
    .catch(error => {
        console.error('Error:', error);
        // Restore button state
        updateButton.textContent = originalText;
        updateButton.disabled = false;
        alert('Error removing discount code: ' + error.message);
    });
}

// Also clear discount if cart is emptied
function checkCartEmpty() {
    const cartItems = document.querySelectorAll('[name="updates[]"]');
    if (cartItems.length === 0) {
        localStorage.removeItem('appliedDiscountCode');
    }
}

// Run cart empty check on page load
document.addEventListener('DOMContentLoaded', checkCartEmpty);